import * as React from 'react';
import { withStyles, createStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const jss = (theme: Theme) => createStyles({
    container: {
        display: 'flex',
        width: '100%',
        maxWidth: '400px',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        padding: theme.spacing.unit,
    },
    section: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    digits: {
        backgroundColor: theme.palette.primary.main,
        borderRadius: '5px',
        marginBottom: '5px',
        padding: theme.spacing.unit * 2,
    },
    contrastText: {
        color: theme.palette.primary.contrastText,
    },
});

interface Props {
    to: number;
    title?: string;
    onEnd: () => void;
    classes: {
        container: string;
        section: string;
        digits: string;
        contrastText: string;
    }
}

interface State {
    time: number;
}

export class Countdown extends React.Component<Props, State> {
    private timeInterval: number;
    constructor(props: Props) {
        super(props);
        this.state = {
            time: Math.max(props.to - Date.now(), 0),
        }
    }

    componentDidMount() {
        if (this.state.time !== 0) {
            this.timeInterval = window.setInterval(this.setTime, 1000);            
        }
    }

    componentWillUnmount() {
        window.clearInterval(this.timeInterval);
    }

    private setTime = () => {
        const time = this.props.to - Date.now();
        if (time <= 0) {
            this.componentWillUnmount();
            this.props.onEnd();
        } else {
            this.setState({ time });
        }
    };

    private format = (num: number) => {
        return String("0" + num).slice(-2);
    };

    render() {
        const { classes } = this.props;

        const date = this.state.time;
        const days = Math.floor(date / (1000 * 60 * 60 * 24));
        const hours = Math.floor((date % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((date % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((date % (1000 * 60)) / 1000);

        return (
            <div className={classes.container}>
                <div className={classes.section}>
                    <div className={classes.digits}>
                        <Typography className={classes.contrastText} variant="h6">{this.format(days)}</Typography>
                    </div>
                    <Typography variant="caption">DAYS</Typography>
                </div>

                <div className={classes.section}>
                    <div className={classes.digits}>
                        <Typography className={classes.contrastText} variant="h6">{this.format(hours)}</Typography>
                    </div>
                    <Typography variant="caption">HOURS</Typography>
                </div>

                <div className={classes.section}>
                    <div className={classes.digits}>
                        <Typography className={classes.contrastText} variant="h6">{this.format(minutes)}</Typography>
                    </div>
                    <Typography variant="caption">MINUTES</Typography>
                </div>

                <div className={classes.section}>
                    <div className={classes.digits}>
                        <Typography className={classes.contrastText} variant="h6">{this.format(seconds)}</Typography>
                    </div>
                    <Typography variant="caption">SECONDS</Typography>
                </div>
            </div>
        );
    }
};

export default withStyles(jss)(Countdown);


// WEBPACK FOOTER //
// ./src/components/Quiz/Countdown.tsx